import React, { useState,useEffect } from 'react';
import { DownloadFile } from './Function';
import { Card,Table,Placeholder, Button } from 'react-bootstrap';
const DynamicMiscellaneousList = ({mtId,textClass}) => 
{
    const appLanguage = localStorage.getItem('appLanguage') || 'en';
    const[isLoading, setLoading] = useState(true);
    const[MiscellaneousType,setMiscellaneousType]=useState([]);
    useEffect(()=>
    {
        const MiscellaneousType = async () => 
        {
            try 
            {
                const response = await fetch(global.config.API_URL+"miscellaneousType/byId/"+mtId);
                const result = await response.json();
                if(result.length > 0 )
                {
                    setMiscellaneousType(result);                    
                }
                if( global.config.IsPrint === true ) { console.info('MiscellaneousType : Result',result); }
            }
            catch (error) 
            {
                console.error('MiscellaneousType : Error', error.message);
            }
            finally
            {
                setLoading(false);
            }
        };
        MiscellaneousType();
    },[mtId])
    return (
        <React.Fragment>
            {isLoading ? ( 
                <Card className=' mb-4'>
                    <Card.Header className={textClass ? `${textClass} text-center fs-3` : `text-center fs-3 text-uppercase`} >
                        <Placeholder xs={10} />
                    </Card.Header>
                    <Card.Body>
                        <Table responsive bordered className='rounded-top text-center overflow-hidden mb-0'>
                            <thead>
                            <tr>
                                <th>{appLanguage === 'hi' ? 'शीर्षक' : 'Title'}</th>
                                <th className='w-25'>{appLanguage === 'hi' ? 'डाउनलोड' : 'Download'}</th>
                            </tr>
                            </thead>
                            <tbody>
                                {[...Array(10)].map((_,index)=>(
                                <tr key={index}>
                                    <th className="table-success"><Placeholder xs={10} /></th>                            
                                    <td className="text-center">
                                        <Button className="btn btn-light w-75"><Placeholder xs={12} /></Button>
                                    </td>                            
                                </tr>
                                ))}
                            </tbody>
                        </Table>
                    </Card.Body>
                </Card>
            ) : (
                <React.Fragment>
                {MiscellaneousType.map((mt,index)=>(
                <Card className=' mb-4' key={index}>
                    <Card.Header className={textClass ? `${textClass} text-center fs-3` : `text-center fs-3 text-uppercase`}>
                        {appLanguage === 'hi' ? (mt.mt_display_en === "1" ? mt.mt_name_hi || '' : mt.mt_name_hi || mt.mt_name) : mt.mt_name}
                    </Card.Header>
                    <Card.Body>
                        <MiscellaneousList mtId={mt.mt_id} />
                    </Card.Body>
                </Card>
                ))}
                </React.Fragment>
            )}
        </React.Fragment>
    );
}
export default DynamicMiscellaneousList;
const MiscellaneousList = ({mtId}) => 
{
    const appLanguage = localStorage.getItem('appLanguage') || 'en';
    const[isLoading, setLoading] = useState(true);
    const[Miscellaneous,setMiscellaneous]=useState([]);
    useEffect(()=>
    {
        const MiscellaneousByType = async () => 
        {
            try 
            {
                const response = await fetch(global.config.API_URL+"miscellaneous/byTypeAll/"+mtId);
                const result = await response.json();
                if(result.length > 0 )
                {
                    Promise.all(
                        result.map(e => {
                            const fetch1 = fetch(global.config.API_URL + "upload/details/0/" + e.sm_id + "/miscFile")
                                .then(upp => upp.json());
                            const fetch2 = fetch(global.config.API_URL + "upload/details/0/" + e.sm_id + "/miscFileHi")
                                .then(upb => upb.json());
                            return Promise.all([fetch1, fetch2])
                                .then(([upp, upb]) => {
                                    return {
                                        ...e,
                                        upp,
                                        upb
                                    };
                                });
                        })
                    ).then(allResponse => {   
                        allResponse.forEach((el, i) => {
                            result[i].miscFile = el.upp;
                            result[i].miscFileHi = el.upb;
                        });
                        setMiscellaneous(result);
                    }).catch(error => {
                        console.error('Miscellaneous File :', error);
                    });
                }
                if( global.config.IsPrint === true ) { console.info('MiscellaneousByType : Result',result); }
            }
            catch (error) 
            {
                console.error('MiscellaneousByType : Error', error.message);
            }
            finally
            {
                setLoading(false);
            }
        };
        MiscellaneousByType();   
    },[mtId])
    return (
        <Table responsive bordered className='rounded-top text-center overflow-hidden mb-0'>
            <thead>
            <tr>
                <th>{appLanguage === 'hi' ? 'शीर्षक' : 'Title'}</th>
                <th className='w-25'>{appLanguage === 'hi' ? 'डाउनलोड' : 'Download'}</th>
            </tr>
            </thead>
            {isLoading ? (
            <tbody>
                {[...Array(10)].map((_,index)=>(
                <tr key={index}>
                    <th className="table-success"><Placeholder xs={10} /></th>                            
                    <td className="text-center">
                        <Button className="btn btn-light w-75"><Placeholder xs={12} /></Button>
                    </td>                            
                </tr>
                ))}
            </tbody>
            ) : (
            <tbody>
                {Miscellaneous.map((sm,index)=>(
                <tr key={index}>
                    <th className="table-success" dangerouslySetInnerHTML={{ __html: appLanguage === 'hi' ? (sm.sm_display_en === "1" ? sm.sm_name_hi || '' : sm.sm_name_hi || sm.sm_name) : sm.sm_name}}></th>                            
                    <td className="text-center" dangerouslySetInnerHTML={{ __html: DownloadFile(appLanguage,sm.miscFile,sm.miscFileHi)}} />
                </tr>
                ))}
            </tbody>
            )}
        </Table>
    );
}